import React from 'react';
import { buildUrl, VALID_URLS } from 'Douleutaras/utilities/url-builder';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesCategoriesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesCategoriesSlice';

import './CategoryLink.scss';

export const CategoryLink = props => {
  const category = useAppSelector(state => sellerProfilesCategoriesSelectors.selectById(state, props.id).attributes);

  // Don't list if not active, activated or availableForJon
  if (!category.activate || !category.activate || !category.availableForJob) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <li styleName="link-list__item">
      <span className="dashicon dashicon-chevron-right" styleName="link-list__icon" />
      <a href={buildUrl(VALID_URLS.CATEGORY, props.id)} styleName="link-list__link">{category.title}</a>
    </li>
  );
};

export default CategoryLink;
